export default function IconSelect3dUltimate() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="Select-3d--Streamline-Ultimate" height="100%" width="100%">
			<desc>{'\n    Select 3d Streamline Icon: https://streamlinehq.com\n  '}</desc>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="m15.8 21.65 -2.7 1.3c-0.3 0.1 -0.7 0.2 -1.1 0.2"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="m8.2 21.65 2.7 1.3c0.3 0.1 0.7 0.2 1.1 0.2"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="M15.8 2.25 13.1 0.95c-0.3 -0.1 -0.7 -0.2 -1.1 -0.2"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="m8.2 2.25 2.7 -1.3c0.3 -0.1 0.7 -0.2 1.1 -0.2"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="M15.3 9.85001 13.1 10.95c-0.3 0.1 -0.7 0.2 -1.1 0.2"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="M8.7 9.85001 10.9 10.95c0.3 0.1 0.7 0.2 1.1 0.2"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="m3.75 16.05 -1.86076 0.8669c-0.39174 0.0963 -0.68556 0.3853 -0.88143 0.7706"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="M0.75 14.45v2.3c0 0.7 0.40001 1.4 1.10001 1.7l1.89999 1"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="m4.14999 4.14999 -2.29998 1.1c-0.6 0.3 -1.10001 0.9 -1.10001 1.7v2.2"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="M1.09375 5.89062c0.19708 0.29324 0.39416 0.48872 0.68979 0.58647L4.05 7.65001"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="m20.25 16.05 1.8608 0.8669c0.3917 0.0963 0.6855 0.3853 0.8814 0.7706"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="M23.25 14.45v2.3c0 0.7 -0.4 1.4 -1.1 1.7l-1.9 1"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="m19.85 4.14999 2.3 1.1c0.6 0.3 1.1 0.9 1.1 1.7v2.2"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				d="M22.9062 5.89062c-0.197 0.29324 -0.3941 0.48872 -0.6897 0.58647L19.95 7.65001"
				strokeWidth={1.5}
			/>
			<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} d="M12 19.35v3.8" strokeWidth={1.5} />
			<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} d="M12 11.15v3.9" strokeWidth={1.5} />
			<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} d="M12 0.75v3.2" strokeWidth={1.5} />
		</svg>
	);
}
